export default __webpack_public_path__ + "fd9a292d01c317d6b0558cef2988271c.svg";